import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Form, DatePicker, Button, Card, Col, Row, Input } from "antd";
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';
import dayjs from "dayjs";
import config from '../../config';

const { RangePicker } = DatePicker;

const VehicleRentalSelectForm = forwardRef(({ initialValues, vehicles, loading, setSelectedVehicle, selectedVehicle, setSelectedVehicleReturn, selectedVehicleReturn, isReturn }, ref) => {


    const convertCurrency = useCurrencyConverter();
    const { currency } = useCurrency();

    const [form] = Form.useForm();
    const [selectedDateRange, setSelectedDateRange] = useState([]);

    const handleDateRangeChange = () => {
        setSelectedDateRange(form.getFieldValue("dateRange"));
    } 

    useImperativeHandle(ref, () => ({
        submit: () => {
            form.submit();
        },
        validate: async () => {
            try {
                const values = await form.validateFields(); // Validate form fields
                return { valid: true, values }; // Return valid status and values
            } catch (error) {
                return { valid: false, errors: error.errorFields }; // Return errors if validation fails
            }
        },
        values: () => {
            return form.getFieldsValue();
        }
    }));

    const handleClick = (vehicle) => {
        setSelectedVehicle(vehicle)
    }

    const onFinish = (values) => {
        console.log("Form Values:", values);
    };

    const sortVehiclesByPrice = (vehicles) => {
        return [...vehicles].sort((a, b) => {
            return Number(a.perDayPricePKR) - Number(b.perDayPricePKR);
        });
    }

    return (
        <div className="vehicle-plans">
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={
                    {...initialValues}
                }
            >
                <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e' }}>
                    Select Dates and Locations
                </div>
                <Row gutter={16} style={{ margin: '1rem', padding: '1rem', borderRadius: '8px', border: '1px solid #00803e' }}>
                    <Col span={24} style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Form.Item
                            name="dateRange"
                            label="Select Date Range"
                            rules={[{ required: true, message: "Please select a date range!" }]}
                        >
                            <RangePicker onChange={handleDateRangeChange} format="DD MMMM YYYY" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="pickupLocation"
                            label="Pickup Location"
                            rules={[
                                { required: true, message: "Please enter pickup location!" },
                                { max: 100, message: "Pickup location cannot exceed 100 characters" }
                            ]}
                        >
                            <Input placeholder="Enter pickup location" maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="dropoffLocation" 
                            label="Drop off Location"
                            rules={[
                                { required: true, message: "Please enter drop off location!" },
                                { max: 100, message: "Drop off location cannot exceed 100 characters" }
                            ]}
                        >
                            <Input placeholder="Enter drop-off location" maxLength={100} />
                        </Form.Item>
                    </Col>
                </Row>

                {selectedDateRange && 
                    <div className="font-bold text-center text-black text-xl mt-4">
                        <p className="!text-2xl">Vehicle Booked For Duration:</p>
                        <div className={"flex flex-row justify-center gap-4 text-base mb-4"}>
                            <span>{dayjs(selectedDateRange[0]).format("DD MMMM YYYY")} - {dayjs(selectedDateRange[1]).format("DD MMMM YYYY")}</span>
                            <span className="font-semibold">
                                ({dayjs(selectedDateRange[1]).diff(dayjs(selectedDateRange[0]), 'day') + 1} days)
                            </span>
                        </div>
                    </div>
                }
                <div className="font-bold text-center text-lg mt-4" style={{ color: 'red' }}>
                    Important Info: Vehicles are provided with driver only. Self drive option is not available.
                </div>

                <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e' }}>
                    Select Rental Vehicle
                </div>
                <div>

                </div>
                <div className='grid lg:grid-cols-4 md:grid-cols-3 mx-auto !mt-6'>
                    {
                        sortVehiclesByPrice(vehicles || [])?.map((vehicle) => {
                            return (
                                <Card
                                    onClick={() => { handleClick(vehicle) }}
                                    className='!mx-auto mb-12 !mt-8 vehicle-card cursor-pointer'
                                    hoverable
                                    style={{
                                        width: 240,
                                        backgroundColor: '#E5E4E2',
                                        borderRadius: '8px',
                                        border: selectedVehicle?.id == vehicle?.id ? '5px solid #00803e' : ''
                                    }}
                                    cover={<img alt="example" className='h-[138px]' style={{
                                        objectFit: 'contain'
                                    }} src={`${config.API_URL}/${vehicle.picture}`} />}
                                >
                                    <div className='text-lg font-bold' style={{ backgroundColor: '#00803e', color: 'white' }}>
                                        {vehicle.name}
                                    </div>
                                    <div className='text-base pt-1 font-semibold'>
                                        {vehicle.passengersCapacity + ' Passengers'}
                                    </div>
                                    <div className='text-base pt-1 font-semibold'>
                                        {currency} {convertCurrency(Number(vehicle.perDayPricePKR))} per day
                                    </div>
                                    <Button type='button' className='w-full mt-2' style={{
                                        backgroundColor: '#00803e',
                                        color: '#ffffff'
                                    }}>Select</Button>
                                </Card>
                            )
                        })
                    }
                </div>
                {
                    loading &&
                    'Loading...'
                }
            </Form>
        </div>
    );
});

export default VehicleRentalSelectForm;
